export default {
  isWX () {
    return window.navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 ? true : false
  }
}



// WEBPACK FOOTER //
// ./src/utils/Window.js